import { render } from "./ConfigLiveDataHeader.vue?vue&type=template&id=10ee7b30"
import script from "./ConfigLiveDataHeader.vue?vue&type=script&lang=js"
export * from "./ConfigLiveDataHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__